export const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;
export const STORE_KEY = process.env.REACT_APP_SHOPI_STYLE_APP;
export const STRIPE_PUBLISH_KEY = process.env.REACT_APP_STRIPE_PUBLISH_KEY;